<template>
    <footer>
        <div class="footer-links">
            <ul class="mb-10">
                <li><a href="/faqs">FAQs</a></li>
                <li>|</li>
                <li><a href="/tnc">Terms and Conditions</a></li>
                <li>|</li>
                <li><a href="https://www.ulta.com/company/privacy" target="_blank">Privacy Policy</a></li>
            </ul>
            <slot name="after-links"></slot>
            <div class="copyright fs-3 txt-black pt-2">Copyright 2000 - <span>{{currentYear}}</span> Ulta Beauty, Inc.</div>
        </div>

    </footer>
</template>

<script>
export default {
    name: "FooterComponent",
    data() {
        return {
            currentYear:window.appGlobalData.currentYear
        }
    }
}
</script>
